const dumb = () => {};

/**
 * Watch the matching or not of a media query
 *
 * @param {Object} params
 * @param {string} params.mediaQuery Media query string
 * @param {function()} params.fnMatches function to execute when the media query
 * changes to matches
 * @param {function()} params.fnNotMatches function to execute when the media
 * query changes to a not matches state
 * @returns {function()} Function for removing the watcher
 */
function watchMediaQuery({
  mediaQuery = '(min-width: 768px)',
  fnMatches = dumb,
  fnNotMatches = dumb,
}) {
  function mediaQueryWatcher({ matches = false } = {}) {
    if (matches) {
      fnMatches();
    } else {
      fnNotMatches();
    }
  }

  let mql = window.matchMedia(mediaQuery);
  mql.addEventListener('change', mediaQueryWatcher);

  // First invocation
  mediaQueryWatcher(mql);

  return function removeMediaQueryWatcher() {
    mql.removeEventListener('change', mediaQueryWatcher);
    mql = undefined;
  };
}

export {
  // eslint-disable-next-line import/prefer-default-export
  watchMediaQuery,
};
